import { Avatar } from '@/utils/types';
import { find, range } from 'lodash';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { LoadingIndicator, useTranslate } from 'react-admin';
import Box from '@mui/material/Box';
import { Skeleton } from '@mui/material';

interface Props {
    title: React.ReactNode;
    items: Avatar[];
    hasNext: boolean;
    isFetching: boolean;
    isLoading: boolean;
    loadMore: any;
    handleToggleAll: any;
    handleToggle: any;
    numberOfChecked: any;
    checked: Avatar[];
}

const CustomList = ({
    title,
    hasNext,
    items,
    loadMore,
    handleToggleAll,
    handleToggle,
    numberOfChecked,
    checked,
    isFetching,
    isLoading,
}: Props) => {
    const translate = useTranslate();
    return (
        <Card>
            <CardHeader
                sx={{ px: 2, py: 1 }}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items?.length && items?.length !== 0}
                        indeterminate={numberOfChecked(items) !== items?.length && numberOfChecked(items) !== 0}
                        disabled={items?.length === 0}
                        inputProps={{
                            'aria-label': 'all items selected',
                        }}
                    />
                }
                title={title}
                subheader={`${numberOfChecked(items)}/${items?.length} ${translate('users.assign.selected')}`}
            />
            <Divider />
            <List
                sx={{
                    width: '100%',
                    height: 230,
                    bgcolor: 'background.paper',
                    overflow: 'auto',
                }}
                dense
                component='div'
                role='list'
            >
                {isLoading ? (
                    <>
                        {range(3).map((v) => (
                            <ListItemButton key={v}>
                                <ListItemIcon>
                                    <Checkbox
                                        // checked={!!find(checked, ({ id: search_id }) => search_id === item.id)}
                                        // tabIndex={-1}
                                        disableRipple
                                        // inputProps={{
                                        //     'aria-labelledby': labelId,
                                        // }}
                                    />
                                </ListItemIcon>
                                <ListItemText primary={<Skeleton />} />
                            </ListItemButton>
                        ))}
                    </>
                ) : (
                    <>
                        {items?.map((item: Avatar) => {
                            const labelId = `transfer-list-all-item-${item.id}-label`;
                            const parentName = item?.parent?.name || item?.customFields?.['parent.name'];

                            return (
                                <ListItemButton key={item.id} role='listitem' onClick={handleToggle(item)}>
                                    <ListItemIcon>
                                        <Checkbox
                                            checked={!!find(checked, ({ id: search_id }) => search_id === item.id)}
                                            tabIndex={-1}
                                            disableRipple
                                            inputProps={{
                                                'aria-labelledby': labelId,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText id={labelId} primary={`${item.name}${parentName ? ` (${parentName})` : ''}`} />
                                </ListItemButton>
                            );
                        })}
                        {hasNext && (
                            <ListItemButton role='listitem' onClick={() => loadMore()}>
                                {isFetching ? (
                                    <Box width={'100%'} display={'grid'} alignItems={'center'} justifyItems={'center'}>
                                        <LoadingIndicator />
                                    </Box>
                                ) : (
                                    <ListItemText
                                        primaryTypographyProps={{ textAlign: 'center' }}
                                        primary={translate('users.assign.load_more')}
                                    />
                                )}
                            </ListItemButton>
                        )}
                    </>
                )}
            </List>
        </Card>
    );
};

export default CustomList;
